import React from 'react';

import './styles.scss';

type Props = {
  priority: number;
};

const PriorityCell = ({ priority }: Props) => {
  let renderedComponent = <span>{priority}</span>;

  switch (priority) {
    case 5:
    case 11:
    case 16:
      renderedComponent = <span className="PriorityCell-normal">Normal</span>;
      break;

    case 10:
    case 15:
    case 20:
      renderedComponent = <span className="PriorityCell-high">High</span>;
      break;

    case 1:
    case 6:
    case 12:
      renderedComponent = <span className="PriorityCell-low">Low</span>;
      break;
    default:
  }

  return renderedComponent;
};

export default PriorityCell;
